import Elmahio from 'elmah.io.javascript/dist/elmahio'

export default {
  install(Vue) {
    const { VM_ENV } = process.env

    if (VM_ENV === 'production') {
      Vue.prototype.$log = new Elmahio({
        apiKey: '70591012e7134d3898d7fc80d1706e14',
        logId: 'db20290b-44ea-4535-84f5-d991aa6fe70c',
      })
    } else {
      Vue.prototype.$log = function (...value) { console.log(`[CoteiBem] DevMode :: Elmah Log : ${JSON.stringify(value)}`) }
    }
  }
}